<!-- cart-is-empty -->
<div class="text-center mb-5">
    <i class="fa fa-shopping-cart cursor-pointer cart-icon">
        <span class="badge cart-counter">0</span>
    </i>
    <h2 class="fw-bold app-primary-text" translate>Your shopping cart is currently empty</h2>
    <p translate>Please click the Continue Shopping button below to return to home page</p>
    <div class="btn-empty-cart">
        <a [routerLink]="[link]"
           class="btn app-third-hover-btn"
           translate>Back to homepage
        </a>
    </div>

</div>
<!-- /cart-is-empty -->
